export default {
  signature: {
    searchPlaceholder: '合同编号',
    contractNumber: '合同编号',
    contractName: '合同名称',
    contractType: '合同类型',
    signDate: '签订日期',
    startDate: '生效日期',
    endDate: '失效日期',
    jiaOrganization: '甲方',
    yiOrganization: '乙方',
    contractDesc: '合同描述',
    notifyNumber: '到期提醒天数',
    operations: ['发起签署', '查看详情', '打印', '下载'],
    jiaChargePerson: '甲方经办人',
    yiChargePerson: '乙方经办人',
    jiaPhone: '甲方手机',
    yiPhone: '乙方手机'
  }
}
